var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule-english-hybrid"},[(_vm.$store.getters.isUIAVendor)?_c('RuleEnglishUIA',{attrs:{"rule":_vm.rule}}):_c('RuleEnglish',{attrs:{"rule":_vm.rule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }